import { __awaiter } from 'tslib';
import { getItem, SESSION_STORAGE } from '@analytics/storage-utils';
import { getToken } from '../../utils/accessToken.js';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import 'react';
import '../../utils/ErrorProvider.js';
import '../../utils/LoaderProvider.js';
import '../../utils/RefetchProvider.js';
import '../../utils/NotificationProvider.js';
import '../../utils/ContactProvider.js';
import '../../utils/PolicyProvider.js';
import '../../utils/AnalyticsProvider.js';
import '../../types/AccessDevice.js';
import '../../types/Analytics.js';
import '../../types/CASACommunity.js';
import '../../types/Community.js';
import '../../types/DxSettings.js';
import '../../types/MagicButton.js';
import '../../types/Pannellum.js';
import '../../types/Prospect.js';
import '../../types/ProspectIntelligence.js';
import '../../types/Space.js';
import '../../types/Tour.js';
import '../../utils/analyticsPlugin.js';
import '../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../utils/cookieUtils.js';
import '../../utils/termsConditionsAgreementsUtils.js';

const requestFactory = (method) => (url, data, onData, config) => __awaiter(void 0, void 0, void 0, function* () {
    const sessionId = getItem("peek__session_id", { storage: SESSION_STORAGE });
    const headers = (config === null || config === void 0 ? void 0 : config.headers) || {};
    if (sessionId) {
        headers["X-Amzn-Trace-Id"] = `PeekSessionId=${sessionId}`;
    }
    const token = getToken();
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    const response = yield fetch(`${process.env.PEEK_APP_API_URL}${url}`, {
        method,
        headers,
        body: data && JSON.stringify(data),
    });
    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    while (true) {
        const { value, done } = yield reader.read();
        if (done)
            break;
        buffer += decoder.decode(value, { stream: true });
        let boundaryIndex;
        while ((boundaryIndex = buffer.indexOf("data:")) !== -1) {
            const chunk = buffer.slice(0, boundaryIndex + 5); // Adjust based on chunk format
            buffer = buffer.slice(boundaryIndex + 5);
            onData(chunk);
        }
    }
});
const serverSideEventService = {
    post: requestFactory("POST"),
};

export { serverSideEventService as default };
